import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../../components/shared/services';

@Component({
  selector: 'app-reset-password',
  standalone: true,  // Mark as standalone component
  imports: [CommonModule, FormsModule],  // Include required modules here
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  newPassword = '';
  confirmPassword = '';
  loading = false;
  errorMessage: string | null = null;
  successMessage: string | null = null;
  token = '';
  tokenValid = false;
  checkingToken = true; // To control UI during validation
  showPassword: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.token = this.route.snapshot.queryParams['token'];


    if (this.token) {
      this.authService.validateResetToken(this.token).subscribe({
        next: (response) => {
          this.tokenValid = response.valid;
          this.checkingToken = false;
        },
        error: () => {
          this.tokenValid = false;
          this.checkingToken = false;
          this.errorMessage = 'Error validating token. Please request a new password reset.';
        }
      });
    } else {
      this.tokenValid = false;
      this.checkingToken = false;
    }
  }
  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
  async onSubmit(event: Event) {
    event.preventDefault();
    this.loading = true;
    this.errorMessage = null;

    if (this.newPassword !== this.confirmPassword) {
      this.errorMessage = 'Passwords do not match';
      this.loading = false;
      return;
    }

    try {
      await this.authService.resetPassword(this.token, this.newPassword).toPromise();
      this.successMessage = 'Password reset successfully! Redirecting to login...';
      setTimeout(() => this.router.navigate(['/login']), 2000);
    } catch (error: any) {
      this.errorMessage = error.error?.message || 'Password reset failed. Please try again.';
    } finally {
      this.loading = false;
    }
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }
}

